import {Box, Button, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {useContext} from "react";
import {IconExternalLink} from "@tabler/icons-react";
import {SignInContext} from "../../../context/SignInContext";
import {c, maxW} from "../landingTokens";
import logo from "../../../assets/logo.svg";

const NAV = [
  {label: "How it works", href: "#how"},
  {label: "Capabilities", href: "#capabilities"},
  {label: "Integrations", href: "#integrations"},
  {label: "Specs", href: "#specs"},
  {label: "FAQ", href: "#faq"},
];

const scrollToContact = () => {
  document.getElementById("contact")?.scrollIntoView({behavior: "smooth", block: "start"});
};

export const LandingHeader = () => {
  const {currentUser} = useContext(SignInContext);

  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        bgcolor: "rgba(248,249,252,0.78)",
        backdropFilter: "saturate(180%) blur(20px)",
        borderBottom: `1px solid ${c.line}`,
      }}
    >
      <Stack
        component="nav"
        direction="row"
        alignItems="center"
        gap={{xs: 2, md: 4.25}}
        sx={{maxWidth: maxW, mx: "auto", height: {xs: 62, md: 70}, px: 2.75}}
      >
        <Box
          component={Link}
          to="/"
          aria-label="OpenBrain home"
          sx={{display: "inline-flex", alignItems: "center", gap: 1.1, color: c.ink, textDecoration: "none"}}
        >
          <Box component="img" src={logo} alt="" sx={{width: 20, height: 24, objectFit: "contain"}} />
          <Typography sx={{fontSize: 18, fontWeight: 700, letterSpacing: "-0.035em", color: "inherit"}}>
            OpenBrain
          </Typography>
        </Box>

        <Stack direction="row" gap={3.25} sx={{flex: 1, display: {xs: "none", md: "flex"}}}>
          {NAV.map((item) => (
            <Typography
              key={item.href}
              component="a"
              href={item.href}
              sx={{fontSize: "13px", color: c.inkSoft, textDecoration: "none", transition: "color 180ms ease", "&:hover": {color: c.purpleInk}}}
            >
              {item.label}
            </Typography>
          ))}
        </Stack>

        <Box sx={{flex: {xs: 1, md: "none"}}} />

        <Typography
          component="a"
          href="https://docs.openbrain.io"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "13px",
            color: c.inkSoft,
            textDecoration: "none",
            display: {xs: "none", sm: "inline-flex"},
            alignItems: "center",
            gap: 0.5,
            "&:hover": {color: c.purpleInk},
          }}
        >
          Docs
          <IconExternalLink size={13} stroke={1.75} />
        </Typography>

        <Typography
          component={Link}
          to={currentUser ? "/projects" : "/login"}
          sx={{fontSize: "13px", color: c.inkSoft, textDecoration: "none", display: {xs: "none", sm: "block"}, "&:hover": {color: c.purpleInk}}}
        >
          {currentUser ? "My Projects" : "Sign in"}
        </Typography>

        <Button
          onClick={scrollToContact}
          variant="contained"
          sx={{
            bgcolor: c.purpleDeep,
            color: c.white,
            borderRadius: "980px",
            textTransform: "none",
            fontSize: "13px",
            fontWeight: 500,
            px: 2.25,
            py: 1.15,
            boxShadow: "none",
            "&:hover": {bgcolor: c.purpleInk, boxShadow: "none", transform: "translateY(-1px)"},
          }}
        >
          Book a free demo
        </Button>
      </Stack>
    </Box>
  );
};
